<div class="container-fluid">
  <div>
    <div class="card-header py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Select Train for Graph
      </h1>
      <div>
        <div class="col-6">
          <label for="name" class="form-label">Plant:</label>
          <select
            class="form-select border border-dark"
            name="plantid"
            (change)="getSelectedId($event)"
          >
            <option [selected]>Select Plant</option>
            <option *ngFor="let plant of plants" [value]="plant.Id">
              {{ plant.Name }}
            </option>
          </select>
        </div>

        <div class="col-6">
          <label for="train" class="form-label">Train:</label>
          <select
            class="form-select border border-dark"
            name="trainid"
            (change)="getSelectedTrainId($event)"
          >
            <option [selected]>Select Train</option>
            <option *ngFor="let train of trains" [value]="train.Id">
              {{ train.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>


